/**
 * Created by tudou on 2020/4/10 20:20.
 */
export default {
  // global
  app: {
    title: 'M-kart',
    todo: 'Todo List',
  },
  common: {
    queryBtn: 'Search',
    resetBtn: 'Reset',
    loading: 'Loading...',
    addBtn: 'Add',
    editBtn: 'Edit',
    viewBtn: 'View',
    downloadBtn: 'Download',
    printBtn: 'Print',
    deleteBtn: 'Delete',
    logBtn: 'Operation Log',
    saveBtn: 'Save',
    submitBtn: 'Submit',
    barUnfold: 'Unfold',
    barFold: 'Fold',
    pageTotal: 'Total',
    pageItem: 'items',
    deleteConfim: 'Are you sure to delete this task?',
  },
};
